.progress {
  min-width: 50px;
}
